import moment from "moment";
import API from "../../libs/api";
import { showAlert } from "../radminUploads";

export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAILED = "UPDATE_USER_FAILED";

export const  GET_USER_INFO_SUCCESS = 'get_user_info_success'

export const UPDATE_USER_FAX_SUCCESS = "UPDATE_USER_FAX_SUCCESS";
export const UPDATE_USER_FAX_FAILED = "UPDATE_USER_FAX_FAILED";

export const GET_INVITED_USERS_REQUEST = "GET_INVITED_USERS_REQUEST";
export const GET_INVITED_USERS_SUCCESS = "GET_INVITED_USERS_SUCCESS";
export const GET_INVITED_USERS_FAILURE = "GET_INVITED_USERS_FAILURE";

export const GET_COMPUTED_REPORT_REQUEST = "GET_COMPUTED_REPORT_REQUEST";
export const GET_COMPUTED_REPORT_SUCCESS = "GET_COMPUTED_REPORT_SUCCESS";
export const GET_COMPUTED_REPORT_FAILURE = "GET_COMPUTED_REPORT_FAILURE";

export const GET_ROLES_PERMISSIONS_REQUEST = "GET_ROLES_PERMISSIONS_REQUEST";
export const GET_ROLES_PERMISSIONS_SUCCESS = "GET_ROLES_PERMISSIONS_SUCCESS";
export const GET_ROLES_PERMISSIONS_FAILURE = "GET_ROLES_PERMISSIONS_FAILURE";

export const setEmailSubscriptionWeekly =
  ({ user, kpiEmailEnabled }) =>
  async (dispatch) => {
    try {
      await API.patchRequest(`/api/v1/user/${user.id}/`, {
        weekly_kpi_email_enabled: kpiEmailEnabled,
      });
      dispatch(
        showAlert(
          "success",
          "Success",
          kpiEmailEnabled
            ? "Weekly kpi stats email successfully subscribed!"
            : "Weelly kpi stats email successfully unsubscribed!"
        )
      );

      let payload = {
        ...user,
        weekly_kpi_email_enabled: kpiEmailEnabled,
      };

      dispatch({
        type: GET_USER_INFO_SUCCESS,
        payload: {
          user: payload
        }
      });
    } catch (error) {
      dispatch(showAlert("danger", "Error", error.message));
      dispatch({
        type: UPDATE_USER_FAILED,
        error,
      });
    }
  };

export const getComputedReport = (pageNumber, id) => async (dispatch) => {
 try {
      dispatch({ type: GET_COMPUTED_REPORT_REQUEST, payload: pageNumber });
      if(id){
 const { data } = await API.getRequest(`/api/v1/report-computed-status-criteria/${id}/?page=${pageNumber}&ordering=-created`);
       dispatch({
      type: GET_COMPUTED_REPORT_SUCCESS,
      payload: {
        items: [data],
        totalItems: 1,
        next: null,
        pageNumber: pageNumber,
      },
    });
      return data;
      }else{
 const { data } = await API.getRequest(`/api/v1/report-computed-status-criteria/?page=${pageNumber}&ordering=-created`);
       dispatch({
      type: GET_COMPUTED_REPORT_SUCCESS,
      payload: {
        items: data?.results,
        totalItems: data?.count,
        next: data?.next,
        pageNumber: pageNumber,
      },
    });
      return data;
      }
   
    } catch (error) {
          dispatch({ type: GET_COMPUTED_REPORT_FAILURE });
      dispatch(showAlert("danger", "Error", error.message));
    }
};

export const UpdateComputedReport = (id, payload) => async (dispatch) => {
 try {
    const { data } = id ? await API.patchRequest(`/api/v1/report-computed-status-criteria/${id}/`, payload) : await API.postRequest(`/api/v1/report-computed-status-criteria/`, payload);

      dispatch(showAlert("success", "Success", `Report setting successfully ${id ? 'updated' : 'created'}!`))

      return data;
    } catch (error) {
      dispatch(showAlert("danger", "Error", error.message));
    }
};

export const deleteReportSetting = (id) => async (dispatch, getState) => {
  try {
    await API.deleteRequest(`/api/v1/report-computed-status-criteria/${id}/`);
    dispatch(getComputedReport(1));

    dispatch(showAlert("success", "Success", "Report setting successfully deleted!"));
    return true;
  } catch (error) {
    dispatch(showAlert("danger", "Error", error.message));
  }
};

export const setEmailSubscriptionMonthly =
  ({ user, kpiEmailEnabled }) =>
  async (dispatch) => {
    try {
      await API.patchRequest(`/api/v1/user/${user.id}/`, {
        monthly_kpi_email_enabled: kpiEmailEnabled,
      });
      dispatch(
        showAlert(
          "success",
          "Success",
          kpiEmailEnabled
            ? "Monthly kpi stats email successfully subscribed!"
            : "Monthly kpi stats email successfully unsubscribed!"
        )
      );

      let payload = {
        ...user,
        monthly_kpi_email_enabled: kpiEmailEnabled,
      };

      dispatch({
        type: GET_USER_INFO_SUCCESS,
        payload: {
          user: payload
        }
      });
    } catch (error) {
      dispatch(showAlert("danger", "Error", error.message));
      dispatch({
        type: UPDATE_USER_FAILED,
        error,
      });
    }
  };

export const setQualityMetricsEmailSubscription =
  ({ user, qualityMetricsEmailEnabled }) =>
  async (dispatch) => {
    try {
      await API.patchRequest(`/api/v1/user/${user.id}/`, {
        quality_metrics_email_enabled: qualityMetricsEmailEnabled,
      });
      dispatch(
        showAlert(
          "success",
          "Success",
          qualityMetricsEmailEnabled
            ? "Quality metrics email successfully subscribed!"
            : "Quality metrics email successfully unsubscribed!"
        )
      );

      let payload = {
        ...user,
        quality_metrics_email_enabled: qualityMetricsEmailEnabled,
      };

      dispatch({
        type: GET_USER_INFO_SUCCESS,
        payload: {
          user: payload
        }
      });
    } catch (error) {
      dispatch(showAlert("danger", "Error", error.message));
      dispatch({
        type: UPDATE_USER_FAILED,
        error,
      });
    }
  };

  
export const setIncomingMessageSubscription =
({ user, incomingMessageEnabled, statusType }) =>
async (dispatch) => {
  try {
    await API.patchRequest(`/api/v1/user/${user.id}/`, {
      notify_incoming_sms: incomingMessageEnabled === false? 'unsubscribe': statusType,
    });
    dispatch(
      showAlert(
        "success",
        "Success",
        incomingMessageEnabled && statusType ==="daily_summary"?
        "Incoming message email daily summary successfully subscribed!"
        :incomingMessageEnabled && statusType ==="immediate"?
        "Incoming message email immediate successfully subscribed!"
        : "Incoming message email successfully unsubscribed!"
      )
    );

    let payload = {
      ...user,
      notify_incoming_sms: incomingMessageEnabled === false? 'unsubscribe': statusType,
    };

    dispatch({
      type: GET_USER_INFO_SUCCESS,
      payload: {
        user: payload
      }
    });
  } catch (error) {
    dispatch(showAlert("danger", "Error", error.message));
    dispatch({
      type: UPDATE_USER_FAILED,
      error,
    });
  }
};

export const setIncomingFaxSubscription =
({ user, incomingFaxEnabled, statusType }) =>
async (dispatch) => {
  try {
   const res = await API.patchRequest(`/api/v1/user/${user.id}/`, {
      notify_incoming_fax: incomingFaxEnabled === false? 'unsubscribe': statusType,
    });
    dispatch(
      showAlert(
        "success",
        "Success",
        incomingFaxEnabled && statusType ==="daily_summary"?
        "Incoming fax email daily summary successfully subscribed!"
        :incomingFaxEnabled && statusType ==="immediate"?
        "Incoming fax email immediate successfully subscribed!"
        : "Incoming fax email successfully unsubscribed!"
      )
    );

    console.log(res?.data?.notify_incoming_fax, 'heyeyeye')

    let payload = {
      ...user,
      notify_incoming_fax: res?.data?.notify_incoming_fax,
    };

    console.log('payload ()', payload)

    console.log('user =()', user)

    dispatch({
      type: GET_USER_INFO_SUCCESS,
      payload: {
        user: payload
      }
    });
  } catch (error) {
    dispatch(showAlert("danger", "Error", error.message));
    dispatch({
      type: UPDATE_USER_FAX_FAILED,
      error,
    });
  }
};

export const setOutgoingFaxSubscription =
({ user, outgoingFaxEnabled, statusType }) =>
async (dispatch) => {
  try {
   const res = await API.patchRequest(`/api/v1/user/${user.id}/`, {
      notify_outgoing_fax: outgoingFaxEnabled === false? 'unsubscribe': statusType,
    });
    dispatch(
      showAlert(
        "success",
        "Success",
        outgoingFaxEnabled && statusType ==="daily_summary"?
        "Outgoing fax email daily summary successfully subscribed!"
        :outgoingFaxEnabled && statusType ==="immediate"?
        "Outgoing fax email immediate successfully subscribed!"
        : "Outgoing fax email successfully unsubscribed!"
      )
    );

    let payload = {
      ...user,
      notify_outgoing_fax: res?.data?.notify_outgoing_fax,
    };


    dispatch({
      type: GET_USER_INFO_SUCCESS,
      payload: {
        user: payload
      }
    });
  } catch (error) {
    dispatch(showAlert("danger", "Error", error.message));
    dispatch({
      type: UPDATE_USER_FAX_FAILED,
      error,
    });
  }
};

export const getInvitedUsers = (pageNumber,search) => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_INVITED_USERS_REQUEST, payload: pageNumber });

    let responseData;
    let totalItems;
    let items;

    const { data } = await API.getRequest(
      `/api/v1/invited-users/?page=${pageNumber}&ordering=-created${search ? `&search=${search}`:""}`
    );
    responseData = data.results.map((itm) => ({
      ...itm,
      date_joined: itm?.date_joined
        ? moment(itm.date_joined).format("YYYY-MM-DD")
        : "",
      last_login: itm.last_login
        ? moment(itm.last_login).format("YYYY-MM-DD")
        : "",
    }));
    totalItems = data.count;

    dispatch({
      type: GET_INVITED_USERS_SUCCESS,
      payload: {
        items: responseData,
        totalItems: totalItems,
        next: responseData.next,
        pageNumber: pageNumber,
      },
    });
  } catch (error) {
    dispatch({ type: GET_INVITED_USERS_FAILURE });
    dispatch(showAlert("danger", "Error", error.message));
  }
};

export const getPermissions = (role) => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_ROLES_PERMISSIONS_REQUEST });

    let responseData;
    let totalItems;

    const { data } = await API.getRequest(
      `/api/v1/invited-users-access/?permission_level=${role}&page_size=100`
    );
    responseData = data.results;
    totalItems = data.count;

    dispatch({
      type: GET_ROLES_PERMISSIONS_SUCCESS,
      payload: {
        items: responseData,
        totalItems: totalItems,
        next: responseData.next,
      },
    });
  } catch (error) {
    dispatch({ type: GET_ROLES_PERMISSIONS_FAILURE });
    dispatch(showAlert("danger", "Error", error.message));
  }
};

export const updateRolePermission = (data) => async (dispatch, getState) => {
  try {
    await API.postRequest(`/api/v1/invited-users-permissions/`, data);

    dispatch(
      showAlert("success", "Success", "Permissions successfully updated!")
    );
  } catch (error) {
    dispatch(showAlert("danger", "Error", error.message));
  }
};

export const inviteUser = (data, id) => async (dispatch, getState) => {
  try {
    if (id) {
      await API.patchRequest(`/api/v1/invited-users/${id}`, data);
      await dispatch(getInvitedUsers(1));

      dispatch(showAlert("success", "Success", "User successfully updated!"));
    } else {
      let result = await API.postRequest(`/api/v1/invited-users/`, data);
      await dispatch(getInvitedUsers(1));

      dispatch(showAlert("success", "Success", "User successfully invited!"));
    }

    return true;
  } catch (error) {
    dispatch(showAlert("danger", "Error", error.message));
  }
};

export const resetPasswordInvitedUser = (id) => async (dispatch, getState) => {
  try {
    await API.postRequest(`/api/v1/invited-users/${id}/reset-password/`);

    dispatch(
      showAlert("success", "Success", "Reset password email successfully sent!")
    );

    return true;
  } catch (error) {
    dispatch(showAlert("danger", "Error", error.message));
  }
};

export const deleteUser = (id) => async (dispatch, getState) => {
  try {
    await API.patchRequest(`/api/v1/invited-users/${id}/`,{is_active:false});
    dispatch(getInvitedUsers(1));

    dispatch(showAlert("success", "Success", "User successfully deleted!"));
    return true;
  } catch (error) {
    dispatch(showAlert("danger", "Error", error.message));
  }
};

export const restoreUser = (id) => async (dispatch, getState) => {
  try {
    await API.patchRequest(`/api/v1/invited-users/${id}/`,{is_active:true});
    dispatch(getInvitedUsers(1));

    dispatch(showAlert("success", "Success", "User successfully resored!"));
    return true;
  } catch (error) {
    dispatch(showAlert("danger", "Error", error.message));
  }
};
